module.exports = __webpack_public_path__ + "static/media/marcinha.fc5cd0a5.jpg";